import * as React from "react";
import { useEffect, useState } from "react";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { Lightbox } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../../react-core/Html/TextBoxEditor";
import { AlphanumericWithSpace } from "../../../../../../../../react-core/Html/Validation/RegExPatterns";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { HierarchyLevelName } from "../../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { setActionMenuParams } from "../../../../../../../DLU/DLUHelper";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { Table } from "../../../../../../../Shared/Table/Table";
import { ValidatorContents } from "../../../../../../Common/ValidatorHelper";
import { SubaccountSideMenuMap } from "../../../../../CustomNavigation/Entities/SubaccountSideMenuMap";
import { accountStatusMap } from "../../../../ClientSearch/Resource/Content";
import { Contents } from "../../Transactions/Resource/Contents";
import { AccountAllowedStatusAction } from "../Action/AccountAllowedStatusAction";
import { ProductOverviewProductInformationAction } from "../Action/ProductOverviewProductInformationAction";

interface IProductOverviewProductInformationProps {
    subAccountHierarchyId: string;
    selectedProduct?: SubAccountType;
    headaccount: ClientAccount;
}

export const ProductOverviewProductInformation = (props: IProductOverviewProductInformationProps) => {
    const subAccount = props.headaccount.SubAccounts.find((ele) => ele.HierarchyId == props.subAccountHierarchyId);
    const [data, setData] = useState(null);
    const [name, setName] = useState<string>(
        subAccount?.ProductDisplayName.startsWith("PP - ")
            ? subAccount?.ProductDisplayName?.replace("PP - ", "")
            : subAccount?.ProductDisplayName
    );
    const [allowedStatus, setAllowedStatus] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [isValid, setIsValid] = useState(true);
    const [isShowEditLightbox, setIsShowEditLightbox] = useState(false);
    const customerid = HierarchyIdHelper.generateHierarchyId(ContextStore.getUrlParamsHierarchyId(ContextType.Customer))
        .entityId;
    useEffect(() => {
        ProductOverviewProductInformationAction.getProductInformation(props.subAccountHierarchyId, (data) => {
            setData(data);
        });
    }, []);

    return (
        <>
            <br />
            <div className="row wide-gutter">
                <div className="col-12 col-sm-fluid col-equalise">
                    <div className="d-flex f-direction-column">
                        <div className="row mb-10">
                            <div className="col-fluid col-middle">
                                <h2 className="h3 mb-0">Product information</h2>
                            </div>

                            <div className="col-auto col-middle">
                                <Permission userClaim={UserClaim.AdviserPortalPortfolioViewRolesReadWrite}>
                                    <button
                                        type="button"
                                        className="edit-circle-icon-button label-sr-only"
                                        title="Edit"
                                        onClick={() => {
                                            AccountAllowedStatusAction.getAccountAllowedStatus(
                                                props.subAccountHierarchyId,
                                                (result) => {
                                                    setAllowedStatus(result);
                                                    setIsShowEditLightbox(true);
                                                }
                                            );
                                        }}
                                    >
                                        <span className="icon" aria-hidden="true"></span>
                                        <span className="text">Edit product name</span>
                                    </button>
                                </Permission>
                                {isShowEditLightbox && (
                                    <Lightbox
                                        cssWrapper="is-default-lightbox"
                                        show={isShowEditLightbox}
                                        onClose={() => setIsShowEditLightbox(false)}
                                        title="Edit product information"
                                    >
                                        {props.selectedProduct == SubAccountType.InvestmentAccount && (
                                            <TextBoxEditor
                                                value={name}
                                                label={"Name"}
                                                onChange={(v) => setName(v)}
                                                required={"Please enter a name"}
                                                cssWrapper="control-size-430 mb-10"
                                                regex={{
                                                    errorMessage: ValidatorContents.AlphaNumericWithSpace,
                                                    value: AlphanumericWithSpace,
                                                }}
                                                onValidationResultChange={(isValid: boolean) => {
                                                    setIsValid(isValid);
                                                }}
                                                maxLength={30}
                                            />
                                        )}

                                        <SelectEditor
                                            id="customerStatus"
                                            label="Status"
                                            options={allowedStatus}
                                            getText={(v) => {
                                                return accountStatusMap[v];
                                            }}
                                            placeholder={"Please select status"}
                                            selected={selectedStatus}
                                            onChange={(v) => setSelectedStatus(v)}
                                        />
                                        <button
                                            className="btn secondary mr-10"
                                            onClick={() => {
                                                if (props.selectedProduct == SubAccountType.InvestmentAccount) {
                                                    setName(
                                                        props.headaccount.SubAccounts.find(
                                                            (ele) => ele.HierarchyId == props.subAccountHierarchyId
                                                        )?.ProductDisplayName
                                                    );
                                                }
                                                setSelectedStatus(null);
                                                setIsShowEditLightbox(false);
                                                setIsValid(true);
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="btn primary"
                                            onClick={() => {
                                                if (isValid) {
                                                    if (props.selectedProduct == SubAccountType.InvestmentAccount) {
                                                        props.headaccount.SubAccounts.find(
                                                            (ele) => ele.HierarchyId == props.subAccountHierarchyId
                                                        ).ProductDisplayName = "PP - " + name;
                                                    }

                                                    setIsValid(true);
                                                    const hierarchyid = props.headaccount.SubAccounts.find(
                                                        (ele) => ele.HierarchyId == props.subAccountHierarchyId
                                                    )?.HierarchyId;

                                                    ProductOverviewProductInformationAction.saveProductInformation(
                                                        hierarchyid,
                                                        name,
                                                        selectedStatus,
                                                        () => {
                                                            setIsShowEditLightbox(false);
                                                            setSelectedStatus(null);
                                                            ProductOverviewProductInformationAction.getProductInformation(
                                                                props.subAccountHierarchyId,
                                                                (data) => {
                                                                    setData(data);
                                                                }
                                                            );
                                                        }
                                                    );
                                                    // ProductOverviewProductInformationAction.updateProductName(
                                                    //     hierarchyid,
                                                    //     name,
                                                    //     () => {
                                                    //         setIsShowEditLightbox(false);
                                                    //     }
                                                    // );
                                                }
                                            }}
                                        >
                                            Apply
                                        </button>
                                    </Lightbox>
                                )}
                            </div>
                        </div>

                        <div className="panel-subtle pt-10 pb-10">
                            {
                                <table className="table-subtle row-higher table-first-last-cell-padding-reset has-first-cell-highlighted">
                                    <tbody>
                                        {props.selectedProduct == SubAccountType.InvestmentAccount && (
                                            <tr>
                                                <th scope="row">Name</th>
                                                <td className="cell-right">{subAccount?.ProductDisplayName}</td>
                                            </tr>
                                        )}
                                        <tr>
                                            <th scope="row">Status</th>
                                            <td className="cell-right">{data?.Status}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Date of closure</th>
                                            <td className="cell-right">
                                                {data?.ClosedDate && data?.ClosedDate + "" != Contents.InvalidateDate
                                                    ? JsonDateParser.getFormatDateString(
                                                          new Date(data?.ClosedDate),
                                                          "dd/MM/yyyy"
                                                      )
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        {(props.selectedProduct == SubAccountType.OffshoreBond ||
                                            props.selectedProduct == SubAccountType.OnshoreBond) && (
                                            <tr>
                                                <th scope="row">Policy number</th>
                                                <td className="cell-right">
                                                    {data?.PolicyNumber && data?.PolicyNumber.length > 0
                                                        ? data?.PolicyNumber
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                        )}
                                        <tr>
                                            <th scope="row">Inception date</th>
                                            <td className="cell-right">
                                                {data?.InceptionTime &&
                                                data?.InceptionTime + "" != Contents.InvalidateDate
                                                    ? JsonDateParser.getFormatDateString(
                                                          new Date(data?.InceptionTime),
                                                          "dd/MM/yyyy"
                                                      )
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Commission paying</th>
                                            <td className="cell-right">{data?.CommissionPaying ? "Yes" : "No"}</td>
                                        </tr>
                                        {data?.CommissionPaying == false && (
                                            <tr>
                                                <th scope="row">Date commission stopped being paid</th>
                                                <td className="cell-right">
                                                    {data?.DateStoppedCommissionPaying &&
                                                    data?.DateStoppedCommissionPaying + "" != Contents.InvalidateDate
                                                        ? JsonDateParser.getFormatDateString(
                                                              new Date(data?.DateStoppedCommissionPaying),
                                                              "dd/MM/yyyy"
                                                          )
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                        )}
                                        {props.selectedProduct == SubAccountType.StocksIsa &&
                                            data?.FormerProductType !== "" && (
                                                <tr>
                                                    <th scope="row">Former product type</th>
                                                    <td className="cell-right">
                                                        {data?.FormerProductType && data?.FormerProductType.length > 0
                                                            ? data?.FormerProductType
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                            )}
                                        {props.selectedProduct == SubAccountType.OffshoreBond && (
                                            <tr>
                                                <th scope="row">Number of segments</th>
                                                <td className="cell-right">
                                                    {data?.NumberOfSegments && data?.NumberOfSegments >= 0
                                                        ? data?.NumberOfSegments
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-fluid col-equalise">
                    <div className="d-flex f-direction-column">
                        {(props.selectedProduct == SubAccountType.InvestmentAccount ||
                            props.selectedProduct == SubAccountType.StocksIsa) && (
                            <>
                                <h3>
                                    Manage income
                                    {/* <a type="button" className="edit-circle-icon-button ml-5" href={"/clients/cash/manageincome.aspx?claccountid=" + getQueryParameters()["claccountid"]} target="_blank">
                                                    <span className="icon"></span>
                                                    <span className="sr-only">Edit Ongoing Adviser Charge</span>
                                    </a> */}
                                </h3>
                                <div className="panel-subtle pt-10 pb-25">
                                    <table className="table-subtle row-higher table-first-last-cell-padding-reset has-first-cell-highlighted mb-15">
                                        <tbody>
                                            <tr>
                                                <th scope="row">Instruction for income funds</th>
                                                <td className="cell-right">{data?.IncomeOption}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {checkPermission(UserClaim.AdviserPortalDluManageIncomeCanView) && (
                                        <div>
                                            <a
                                                href={
                                                    "/clients/cash/manageincome.aspx?claccountid=" +
                                                    props.headaccount?.HeadClAccountId
                                                }
                                                className="hyperlink"
                                                onClick={() => {
                                                    setActionMenuParams({
                                                        headaccounthierarchyId: props.headaccount?.HierarchyId,
                                                        subaccountHierarchyId: subAccount?.HierarchyId,
                                                        levelHierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                            HierarchyLevelName.Customer,
                                                            customerid
                                                        ),
                                                        SideMenu: SubaccountSideMenuMap.getSubMenuBySubAccountType(
                                                            subAccount?.SubAccountType
                                                        ),
                                                    });
                                                }}
                                            >
                                                View or edit income
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <hr />

            {(props.selectedProduct == SubAccountType.OnshoreBond ||
                props.selectedProduct == SubAccountType.OffshoreBond) && (
                <div className="row wide-gutter">
                    <div className="col-12 col-sm-fluid col-equalise">
                        <div className="d-flex f-direction-column">
                            <h2 className="mb-36">Lives Assured</h2> 
                            <div className="row mb-10" style={{ paddingLeft: "2px" }}>
                                <div className="panel-subtle pt-10 pb-10">
                                    <Table
                                        cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                        data={data?.LivesAssured}
                                        col={[
                                            {
                                                title: "Name",
                                                key: "Name",
                                            },
                                            {
                                                title: "Gender",
                                                key: "Gender",
                                            },
                                            {
                                                title: "Date Of Birth",
                                                key: "DateofBirth",
                                            },
                                            {
                                                title: "Address",
                                                key: "Address",
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
